module.exports = __webpack_public_path__ + "static/media/Arcade_4610.50c05512.jpg";